/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Container, Button, Spinner, Modal, Alert } from "react-bootstrap";
import {
  faBriefcase,
  faChartSimple,
  faInfoCircle,
  faLayerGroup,
  faSackDollar,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header from "../Header";
import "./ViewSharedJobDetail.scss";
import useViewSharedJobDetail from "./useViewSharedJobDetail";
import { dateDiff } from "../../../_helpers/dateFormatter";
import Footer from "../Footer/Footer";

function ViewSharedJobDetail(props) {
  const {
    jobDetails,
    jobDetailsLoading,
    jobApplyLoading,
    formSubmitError,
    loading,
    userDetails,
    show,
    userInfo,
    fieldsShown,
    formData,
    formSubmitLoading,
    rejectInvitationModal,

    onJobApplyClick,
    onJobShareClick,
    onViewAllJobsClick,
    handleClose,
    onSubmitForm,
    onProfileUpdate,
    onFormDataChange,
    onAssessmentKitsClick,
    onCalendarDashoardClick,
    onPublicProfileClick,
    onResumeUpload,
  } = useViewSharedJobDetail();

  return (
    <>
      <Header />
      <Container>
        <div className=" job-board-expanded footer-gap">
          <div className="top-cards-wrapper">
            <div className="mb-2 job-list-section">
              <div className="d-flex align-items-center my-3 pb-3">
                <h4 className="text-uppercase mr-4 text-nowrap">
                  WELCOME TO A BETTER JOB SEARCH
                </h4>
                <span className="border-bottom" style={{ width: "85%" }}></span>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 mb-4">
                  <div className="p-4 bg-grey  position-relative h-100 rounded-lg">
                    <div className="card-wrapper">
                      <div className="d-flex mb-3 align-items-start">
                        <div className="job-info">
                          <h4 className="font-weight-medium mb-1 text-capitalize pb-2">
                            Connect your google calendar
                          </h4>
                          <p className="text-grey-4 fs-smallest">
                            Let hiring managers know your availability and
                            schedule interviews with you with a click of a
                            button. Get your very own calendar availability
                            link.
                          </p>
                          <button
                            onClick={onCalendarDashoardClick}
                            className="btn btn-outline-primary mt-4"
                          >
                            Calendar Dashboard
                          </button>
                        </div>
                        <img
                          src={"/assets/images/building-placeholder.png"}
                          alt="company logo"
                          className="border-radius-10 ml-3 card-img"
                          style={{ width: "48px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div className="p-4 bg-grey  position-relative h-100 rounded-lg">
                    <div className="card-wrapper">
                      <div className="d-flex mb-3 align-items-start">
                        <div className="job-info">
                          <h4 className="font-weight-medium mb-1 text-capitalize pb-2">
                            Assessment kits
                          </h4>
                          <p className="text-grey-4 fs-smallest">
                            Never answer the same questions on multiple
                            interviews. Take the assessment kit and your video
                            recorded responses can be shared with any hiring
                            manager you choose. Be instantly hireable
                          </p>
                          <button
                            onClick={onAssessmentKitsClick}
                            className="btn btn-outline-primary mt-4"
                          >
                            Assessment Kits List
                          </button>
                        </div>
                        <img
                          src={"/assets/images/building-placeholder.png"}
                          alt="company logo"
                          className="border-radius-10 ml-3 card-img"
                          style={{ width: "48px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div className="p-4 bg-grey  position-relative h-100 rounded-lg">
                    <div className="card-wrapper">
                      <div className="d-flex mb-3 align-items-start">
                        <div className="job-info">
                          <h4 className="font-weight-medium mb-1 text-capitalize pb-2">
                            Your hiring profile
                          </h4>
                          <p className="text-grey-4 fs-smallest">
                            One link with your calendar availability, your video
                            recorded responses and your resume which you can
                            explicitly share with hiring managers.
                          </p>
                          <button
                            onClick={onPublicProfileClick}
                            className="btn btn-outline-primary mt-4"
                          >
                            Public Profile
                          </button>
                        </div>
                        <img
                          src={"/assets/images/building-placeholder.png"}
                          alt="company logo"
                          className="border-radius-10 ml-3 card-img"
                          style={{ width: "48px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div>
              <div className="top text-right d-flex align-items-center justify-content-end mb-3">
                <button
                  className="btn btn-secondary mr-3"
                  onClick={onJobShareClick}
                >
                  Share Job
                </button>
                <button
                  onClick={onViewAllJobsClick}
                  className="btn btn-primary"
                >
                  View All Jobs
                </button>
              </div>
              <div className="container bg-grey-3 border-radius-10">
                {jobDetailsLoading ? (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <>
                    <div className="job-expanded-info px-4 h-100">
                      {jobDetails?.status === "inactive" ? (
                        <div className="text-center ">
                          <Alert
                            variant={"danger"}
                            className="mt-3 text-center d-inline-flex align-items-center font-weight-medium"
                          >
                            <FontAwesomeIcon
                              icon={faInfoCircle}
                              className="mr-3 h2 mb-0"
                            />
                            This Job has been closed now !
                          </Alert>
                        </div>
                      ) : null}
                      {jobDetails?.title && (
                        <div className="bottom position-relative">
                          <div className="job-meta d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center flex-1">
                              <img
                                src={
                                  jobDetails?.posted_by_details &&
                                  jobDetails?.posted_by_details
                                    ?.company_details &&
                                  jobDetails?.posted_by_details.company_details
                                    ?.logo === null
                                    ? "/assets/images/company-logo-placeholder.png"
                                    : jobDetails?.posted_by_details &&
                                      jobDetails?.posted_by_details
                                        ?.company_details &&
                                      jobDetails?.posted_by_details
                                        .company_details?.logo
                                }
                                alt="company logo"
                                className="border-radius-10 mr-3 align-self-end"
                                style={{
                                  width: "70px",
                                  height: "70px",
                                  objectFit: "cover",
                                }}
                              />
                              <div className="mt-3 text-capitalize">
                                <div className="d-inline-block">
                                  <h3 className="mb-1 text-primary">
                                    {jobDetails?.title}
                                  </h3>
                                  <p className="text-grey-4 mb-1">
                                    <span>
                                      {jobDetails?.posted_by_details &&
                                        jobDetails.posted_by_details
                                          ?.company_details &&
                                        jobDetails.posted_by_details
                                          .company_details?.name}
                                    </span>
                                    ,{" "}
                                    <span className="text-capitalize">
                                      {jobDetails?.state_name},{" "}
                                    </span>
                                    <span className="text-uppercase">
                                      {jobDetails?.country_name}
                                    </span>
                                  </p>
                                  <p className="mb-0 text-grey-4">
                                    <span>
                                      {dateDiff(
                                        jobDetails?.created,
                                        new Date()
                                      )}{" "}
                                      ago
                                    </span>
                                    {", "}
                                    <span>
                                      {jobDetails?.total_candidates} Applicants
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="text-right d-flex">
                              {userDetails?.role === "hiring_manager" ? null : (
                                <>
                                  {userDetails?.role ? (
                                    <>
                                      {userDetails?.user_meta_info &&
                                      userDetails?.user_meta_info?.resume ? (
                                        <>
                                          <button
                                            className="btn btn-primary apply px-4"
                                            disabled={
                                              formSubmitError?.msg ||
                                              (jobDetails &&
                                                jobDetails?.already_applied) ||
                                              jobDetails?.status === "inactive"
                                            }
                                            onClick={() => onJobApplyClick()}
                                          >
                                            {jobApplyLoading ? (
                                              <div className="d-flex justify-content-center align-items-center w-100">
                                                <Spinner
                                                  animation="border"
                                                  variant="white"
                                                />
                                              </div>
                                            ) : (
                                              <>
                                                {formSubmitError?.msg ||
                                                (jobDetails &&
                                                  jobDetails?.already_applied)
                                                  ? "Already Applied"
                                                  : "Apply Now"}
                                              </>
                                            )}
                                          </button>
                                        </>
                                      ) : (
                                        <label
                                          htmlFor="resumeUpload"
                                          className="btn btn-primary"
                                        >
                                          <input
                                            className="d-none"
                                            type="file"
                                            name="resume"
                                            id="resumeUpload"
                                            accept=".pdf"
                                            onChange={onResumeUpload}
                                          />
                                          Upload Resume to Apply
                                        </label>
                                      )}
                                    </>
                                  ) : (
                                    <button
                                      className="btn btn-primary apply px-4"
                                      disabled={
                                        formSubmitError?.msg ||
                                        (jobDetails &&
                                          jobDetails?.already_applied) ||
                                        jobDetails?.status === "inactive"
                                      }
                                      onClick={() => onJobApplyClick()}
                                    >
                                      {jobApplyLoading ? (
                                        <div className="d-flex justify-content-center align-items-center w-100">
                                          <Spinner
                                            animation="border"
                                            variant="white"
                                          />
                                        </div>
                                      ) : (
                                        <>
                                          {formSubmitError?.msg ||
                                          (jobDetails &&
                                            jobDetails?.already_applied)
                                            ? "Already Applied"
                                            : "Apply Now"}
                                        </>
                                      )}
                                    </button>
                                  )}
                                </>
                              )}

                              {formSubmitError?.msg && (
                                <div className="d-flex align-items-center justify-content-end mt-2">
                                  <span className="text-danger font-weight-medium">
                                    {formSubmitError?.msg}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>

                          <ul className="fs-smallest d-flex flex-wrap align-items-center py-5">
                            <li className="p-2 flex-grow-1 d-flex align-items-center">
                              <div className="icon bg-primary rounded-pill mr-3">
                                <FontAwesomeIcon
                                  icon={faBriefcase}
                                  className="p-2 text-white fa-2x ml-1 mt-1"
                                />
                              </div>
                              <div>
                                <p className="mb-0 text-primary font-weight-medium">
                                  <p className="mb-0 text-primary">
                                    Minimum{" "}
                                    {jobDetails?.experience.replace(/_/g, " ")}
                                  </p>
                                </p>
                                <p className="text-grey-4 mb-0">Experience</p>
                              </div>
                            </li>
                            <li className="p-2 flex-grow-1 d-flex align-items-center">
                              <div className="icon bg-primary rounded-pill mr-3">
                                <FontAwesomeIcon
                                  icon={faSackDollar}
                                  className="p-2 text-white fa-2x ml-1 mt-1"
                                />
                              </div>
                              <div>
                                <p className="mb-0 text-primary font-weight-medium text-uppercase">
                                  {jobDetails?.payment_currency}{" "}
                                  {jobDetails?.payment_from} -{" "}
                                  {jobDetails?.payment_to}/
                                  <span className="text-capitalize">
                                    {jobDetails?.payment_type}
                                  </span>
                                </p>
                                <p className="text-grey-4 mb-0">Salary</p>
                              </div>
                            </li>
                            <li className="d-flex align-items-center p-2 flex-grow-1">
                              <div className="icon bg-primary rounded-pill mr-3">
                                <FontAwesomeIcon
                                  icon={faLayerGroup}
                                  className="p-2 text-white fa-2x ml-1 mt-1"
                                />
                              </div>
                              <div>
                                <p className="mb-0 text-primary  font-weight-medium">
                                  {jobDetails?.job_function}
                                </p>
                                <p className="text-grey-4 mb-0">Job Function</p>
                              </div>
                            </li>
                            <li className="d-flex align-items-center p-2 flex-grow-1">
                              <div className="icon bg-primary rounded-pill mr-3">
                                <FontAwesomeIcon
                                  icon={faChartSimple}
                                  className="p-2 text-white fa-2x ml-1 mt-1"
                                />
                              </div>
                              <div>
                                <p className="mb-0 text-primary text-capitalize font-weight-medium">
                                  {jobDetails?.employment_type.replace(
                                    /_/g,
                                    " "
                                  )}
                                </p>
                                <p className="text-grey-4 mb-0">Job Type</p>
                              </div>
                            </li>
                          </ul>

                          <div className="mb-2">
                            <p className="font-weight-medium">
                              Job Description:{" "}
                            </p>
                            <div
                              className="text-grey-4"
                              dangerouslySetInnerHTML={{
                                __html: jobDetails?.role_description,
                              }}
                            ></div>
                          </div>
                          <div className="mb-2">
                            <p className="font-weight-medium">Requirements</p>
                            <div
                              className="text-grey-4"
                              dangerouslySetInnerHTML={{
                                __html: jobDetails?.role_requirements,
                              }}
                            ></div>
                          </div>
                          <div className="mb-2">
                            <p className="font-weight-medium">Benefits</p>
                            <div
                              className="text-grey-4"
                              dangerouslySetInnerHTML={{
                                __html: jobDetails?.role_benefits,
                              }}
                            ></div>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </Container>

      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className="common-modal apply-job-modal"
      >
        <Modal.Header className="bg-primary text-white">
          <Modal.Title className="text-uppercase">
            <h3 className="mb-0 text-white mt-1">{jobDetails?.title}</h3>
          </Modal.Title>
          <FontAwesomeIcon
            icon={faXmark}
            className="text-white fa-2x"
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Body>
          <div className="job-detail mb-3">
            <div className="top bg-grey-2 py-3 px-4">
              <h3 className="font-weight-medium">Personal Details</h3>
            </div>
            <div className="bg-white p-3 border-6 shadow-sm mt-3">
              <div className="row">
                {/* candidate profile */}
                {fieldsShown?.headline && (
                  <div className="col-md-12">
                    <div className="py-1 px-0 form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger"> *</span>
                        Headline
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="text"
                        placeholder="Enter Headline"
                        defaultValue={userInfo?.headline}
                        name={"headline"}
                        onBlur={onProfileUpdate}
                      />
                      {formSubmitError?.headline && (
                        <span className="text-danger mt-1">
                          {formSubmitError?.headline}
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {/* candidate name here */}
                {fieldsShown?.name && (
                  <div className="col-md-6">
                    <div className="py-1 px-0 form-group">
                      <p className="font-weight-medium">
                        {fieldsShown?.name === "mandatory" ? (
                          <span className="text-danger"> *</span>
                        ) : null}{" "}
                        Name
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="text"
                        placeholder="Enter Name"
                        disabled
                        defaultValue={
                          userInfo?.user_details &&
                          userInfo.user_details?.full_name
                        }
                      />
                    </div>
                  </div>
                )}

                {/* candidate email here */}
                {fieldsShown?.email && (
                  <div className="col-md-6">
                    <div className="py-1 px-0 form-group">
                      <p className="font-weight-medium">
                        {fieldsShown?.email === "mandatory" ? (
                          <span className="text-danger"> *</span>
                        ) : null}{" "}
                        Email
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="text"
                        placeholder="Enter Email"
                        disabled
                        defaultValue={
                          userInfo?.user_details && userInfo.user_details?.email
                        }
                      />
                    </div>
                  </div>
                )}

                {/* candidate phone here */}
                {fieldsShown?.phone && (
                  <div className="col-md-6">
                    <div className="py-1 px-0 form-group">
                      <p className="font-weight-medium">
                        {fieldsShown?.phone === "mandatory" ? (
                          <span className="text-danger"> *</span>
                        ) : null}{" "}
                        Phone
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="text"
                        placeholder="Enter Phone Number"
                        defaultValue={
                          userInfo?.user_details &&
                          userInfo.user_details?.user_meta_info &&
                          userInfo.user_details.user_meta_info?.phone
                        }
                        disabled
                      />
                    </div>
                  </div>
                )}

                {/* candidate photo here */}
                {fieldsShown?.photo && (
                  <div className="col-md-6">
                    <div className="py-1 px-0 form-group">
                      <p className="font-weight-medium">
                        {fieldsShown?.photo === "mandatory" ? (
                          <span className="text-danger"> *</span>
                        ) : null}{" "}
                        Photo
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="file"
                        placeholder="Upload Photo"
                        defaultValue={userInfo?.photo}
                        name={"photo"}
                        onBlur={onProfileUpdate}
                      />
                    </div>
                  </div>
                )}

                {/* candidate current salary here */}
                {fieldsShown?.experience && (
                  <div className="col-md-6">
                    <div className="py-1 px-0 form-group">
                      <p className="font-weight-medium">
                        {fieldsShown?.experience === "mandatory" ? (
                          <span className="text-danger"> *</span>
                        ) : null}{" "}
                        Current Salary
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="number"
                        placeholder="Upload Current Salary"
                        defaultValue={userInfo?.current_salary}
                        name={"current_salary"}
                        onBlur={onProfileUpdate}
                      />
                    </div>
                  </div>
                )}

                {/* candidate expected salary here */}
                {fieldsShown?.experience && (
                  <div className="col-md-6">
                    <div className="py-1 px-0 form-group">
                      <p className="font-weight-medium">
                        {fieldsShown?.experience === "mandatory" ? (
                          <span className="text-danger"> *</span>
                        ) : null}{" "}
                        Expected Salary
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="number"
                        placeholder="Expected Salary"
                        defaultValue={userInfo?.expected_salary}
                        name={"expected_salary"}
                        onBlur={onProfileUpdate}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* details */}
          <div className="job-detail mb-3">
            <div className="top bg-grey-2 py-3 px-4">
              <h3>Professional Details</h3>
            </div>
            <div className="bg-white p-3 border-6 shadow-sm mt-3">
              <div className="row">
                {/* candidate summary here */}
                {fieldsShown?.summary && (
                  <div className="col-md-12">
                    <div className="py-1 px-0 form-group">
                      <p className="font-weight-medium">
                        {fieldsShown?.summary === "mandatory" ? (
                          <span className="text-danger"> *</span>
                        ) : null}{" "}
                        Summary
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="text"
                        placeholder="Enter your professional and educational summary"
                        defaultValue={formData?.summary}
                        onChange={onFormDataChange}
                        name="summary"
                      />
                      {formSubmitError?.summary && (
                        <span className="text-danger mt-1">
                          {formSubmitError?.summary}
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {/* candidate cover letter here */}
                {fieldsShown?.cover_letter && (
                  <div className="col-md-6">
                    <div className="py-1 px-0 form-group">
                      <p className="font-weight-medium">
                        {fieldsShown?.cover_letter === "mandatory" ? (
                          <span className="text-danger"> *</span>
                        ) : null}{" "}
                        Cover Letter
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="file"
                        placeholder="Enter cover letter"
                        defaultValue={formData?.cover_letter}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>

        {/* Modal body ends */}
        <Modal.Footer>
          <Button variant="" onClick={handleClose} className="btn btn-dark">
            Close
          </Button>
          {formSubmitError?.msg &&
          formSubmitError?.msg === "Already Applied" ? null : (
            <Button variant="primary" onClick={() => onSubmitForm()}>
              {formSubmitLoading ? (
                <Spinner animation="border" variant="" className="text-white" />
              ) : (
                "Apply"
              )}
            </Button>
          )}
          {formSubmitError ? (
            <span className="text-danger mt-1 font-weight-bold">
              {formSubmitError.msg}
            </span>
          ) : null}
        </Modal.Footer>
      </Modal>

      <Footer />
    </>
  );
}
export default ViewSharedJobDetail;
